import Typography from '@mui/material/Typography';

import { EllipsisTooltip } from '../../EllipsisTooltip';

import { getServiceCode } from './utils/get-service-code.util';

interface Props {
  readonly service: Parameters<typeof getServiceCode>[0];
}

export const ServiceCode = ({ service }: Readonly<Props>) => {
  const code = getServiceCode(service);

  return (
    <EllipsisTooltip title={code}>
      <Typography color="text.secondary" noWrap sx={{ mb: 1.5 }}>
        {code}
      </Typography>
    </EllipsisTooltip>
  );
};
